import Vue from 'vue';

export const useAuthInterface = store => {
  return {
    login: async loginData => await store.dispatch('auth/login', loginData),
    onLoginSuccess: async data => await store.dispatch('auth/loginSuccess', data),
    thirdPartyLogin: async data => await store.dispatch('auth/thirdPartyLogin', data),
    appleLogin: async data => await store.dispatch('auth/appleLogin', data),
    fetchUser: async () => await store.dispatch('auth/fetchUser'),
    logout: async () => await store.dispatch('auth/logout'),
    setUserToken: async (bearerToken, refreshToken) =>
      await store.dispatch('auth/setUserToken', { bearerToken, refreshToken }),
    refreshTokens: async () => await store.dispatch('auth/refreshTokens'),
    initFacebookLogin: async state => {
      const params = {
        /* eslint-disable camelcase */
        client_id: import.meta.env.VITE_FB_CLIENT_ID,
        response_type: 'token',
        redirect_uri: `${Vue.prototype.$currentUrl}/login/social-login`,
        /* eslint-enable */
        display: 'popup',
        state: btoa(JSON.stringify(state))
      };
      const loginUrl = new URL(
        `https://www.facebook.com/v23.0/dialog/oauth?${new URLSearchParams(params).toString()}`
      );
      window.open(loginUrl, '_self');
    },
    initGoogleLogin: async state => {
      const params = {
        /* eslint-disable camelcase */
        client_id: import.meta.env.VITE_GOOGLE_CLIENT_ID,
        code_challenge_method: '',
        response_type: 'token id_token',
        redirect_uri: `${Vue.prototype.$currentUrl}/login/social-login`,
        /* eslint-enable */
        scope: 'profile email',
        prompt: 'consent',
        state: btoa(JSON.stringify(state))
      };
      const loginUrl = new URL(
        `https://accounts.google.com/o/oauth2/auth?${new URLSearchParams(params).toString()}`
      );

      window.open(loginUrl, '_self');
    },

    get isLoggedIn() {
      return store.getters['auth/isLoggedIn'];
    },
    get user() {
      return store.getters['auth/user'];
    },
    get token() {
      return store.getters['auth/accessToken'];
    },
    get refreshToken() {
      return store.getters['auth/refreshToken'];
    },
    get isBusy() {
      return store.getters['auth/isBusy'];
    },
    get hasMfa() {
      return !!store.getters['auth/twoFactorAuthorization']?.enabled;
    },
    get isSelfReactivated() {
      return store.getters['auth/isSelfReactivated'];
    }
  };
};
